const Domain = {
  PouchPass: "https://pouchpass.com",
};
const BusinessSites = {
  ContactUs: `${Domain.PouchPass}/contact/`,
};

export default Object.freeze(BusinessSites);
